module.exports = "/assets/data/96f8fda4503aea2371c49ab3f24b29ba-DE24.data.json";